import React from 'react';
import './style.css'

import BusinessDetails from './components/BusinessDetails';
import ClientScroll from './components/ClientScroll';
import HelpYouBusiness from './components/HelpYouBusiness';
import KeepUptoDate from './components/KeepUptoDate';
import MainSection from './components/MainSection';
import Recognized from './components/Recognized';
import Review from './components/Review';
import Solutions from './components/Solutions'
import ContactUs from './components/ContactUs';
import OneTab from '../../components/AppHelmet/OneTab'
import GTM from '../../components/AppHelmet/GTM'
const PublicHome = () => {
  return (
    <div>
      <OneTab />
      <GTM />
      <MainSection />
      <div className='gap-between-section'>
        <ClientScroll />
      </div>
      <div className='gap-between-section'>
        <Solutions />
      </div>
      <BusinessDetails />
      <div className='gap-between-section'>
        <HelpYouBusiness />
      </div>
      <div className='gap-between-section'>
        <Review />
      </div>
      <div className='gap-between-section'>
        <Recognized />
      </div>
      <div className='gap-between-section'>
        <KeepUptoDate />
      </div>
      <div className='gap-between-section'>
        <ContactUs />
      </div>
    </div>
  );
}

export default PublicHome;
